import { useFetchSalesQuery, useFetchAnalyticsQuery, useFetchBrokendownAnalyticsQuery, useFetchInvitationStatsQuery } from '../statisticsApi';

// Stable default values to prevent new references on every render
const EMPTY_SALES = {};
const EMPTY_ANALYTICS = [];
const EMPTY_INVITATIONS = {};

export const useSales = (dates) => {
  return useFetchSalesQuery(dates, {
    selectFromResult: ({ data, isLoading, isError, error, refetch }) => ({
      sales: data ?? EMPTY_SALES,
      isLoading,
      isError,
      error,
      refetch,
    }),
  });
};

export const useAnalytics = (dates) => {
  return useFetchAnalyticsQuery(dates, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      analytics: data ?? EMPTY_ANALYTICS,
      isLoading,
      isError,
      error,
    }),
  });
};

export const useBrokendownAnalytics = (params) => {
  return useFetchBrokendownAnalyticsQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      analytics: data ?? EMPTY_ANALYTICS,
      isLoading,
      isError,
      error,
    }),
  });
};

export const useInvitations = (dates) => {
  return useFetchInvitationStatsQuery(dates, {
    selectFromResult: ({ data, isLoading, isError, error, refetch }) => ({
      invitations: data ?? EMPTY_INVITATIONS,
      isLoading,
      isError,
      error,
      refetch,
    }),
  });
};
